/* LELO.TO sex toy quiz engine.
 * Data-driven: questions, answer images, branching and product tags come from assets/lelo-quiz-config.json
 * (generated from lelo.com's own quiz by PROJECTS/lelovibes/lelo-to/categories/build_quiz_config.py).
 * Product facts (title, price, image, variant) are read live from /products/<handle>.js so nothing is duplicated.
 * Klaviyo: optional. Fires "Sex Toy Quiz Completed" + list subscription through Klaviyo's client API
 * only when the visitor leaves an email and ticks the privacy box. "Skip to results" never sends anything.
 */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') >= 0) return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, '');
    return '$' + v;
  }

  function Quiz(section) {
    this.section = section;
    this.intro = qs(section, '[data-quiz-intro]');
    this.panel = qs(section, '[data-quiz-panel]');
    this.cfgUrl = section.getAttribute('data-quiz-config');
    this.klaviyo = {
      company: section.getAttribute('data-klaviyo-company') || '',
      list: section.getAttribute('data-klaviyo-list') || '',
      metric: section.getAttribute('data-klaviyo-metric') || 'Sex Toy Quiz Completed'
    };
    this.moneyFormat = section.getAttribute('data-money-format') || '';
    this.assetBase = section.getAttribute('data-asset-base') || '';
    this.cfg = null; this.history = []; this.answers = {}; this.current = null;
    var self = this;
    var start = qs(section, '[data-quiz-start]');
    if (start) start.addEventListener('click', function (e) { e.preventDefault(); self.start(); });
  }

  Quiz.prototype.start = function () {
    var self = this;
    this.history = []; this.answers = {};
    this.intro.hidden = true; this.panel.hidden = false;
    this.panel.innerHTML = '<div class="lvq-loading">Loading…</div>';
    this.panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var p = this.cfg ? Promise.resolve(this.cfg) : fetch(this.cfgUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    p.then(function (cfg) { self.cfg = cfg; self.show(cfg.questions[0].id); })
     .catch(function () { self.panel.innerHTML = '<div class="lvq-loading">The quiz could not load. <a href="' + esc(self.section.getAttribute('data-fallback-url') || '/collections/all') + '">Browse the collection instead</a>.</div>'; });
    this.track('quiz_started', {});
  };

  Quiz.prototype.quit = function () {
    this.panel.hidden = true; this.intro.hidden = false; this.panel.innerHTML = '';
    this.intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Quiz.prototype.question = function (id) {
    for (var i = 0; i < this.cfg.questions.length; i++) if (this.cfg.questions[i].id === id) return this.cfg.questions[i];
    return null;
  };

  /* Next question id: an observed lelo.com transition for the decision answers given so far (cfg.flow), else the
     answer's own `next`, else the question's `next`, else the following question in order whose `when` holds. */
  Quiz.prototype.nextId = function (q, chosen) {
    var nxt = null;
    if (this.cfg.flow) {
      var state = [], self = this;
      this.history.forEach(function (id) {
        var h = self.question(id);
        if (h && h.kind === 'decision') state.push(h.key + '=' + (self.answers[h.key] || []).slice().sort().join('+'));
      });
      var k = state.join('|');
      if (state.length && Object.prototype.hasOwnProperty.call(this.cfg.flow, k)) return this.cfg.flow[k];
    }
    if (q.type === 'single') {
      var a = q.answers.filter(function (x) { return x.id === chosen[0]; })[0];
      if (a && a.next) nxt = a.next;
    }
    if (!nxt && q.next) nxt = q.next;
    if (!nxt) {
      var idx = this.cfg.questions.indexOf(q);
      // skip questions whose `when` condition does not hold
      for (var j = idx + 1; j < this.cfg.questions.length; j++) {
        if (this.applies(this.cfg.questions[j])) { nxt = this.cfg.questions[j].id; break; }
      }
    }
    return nxt || '__email';
  };

  /* `when`: every listed key must have at least one of the listed values answered; `when_not`: none of them may be. */
  Quiz.prototype.applies = function (q) {
    var ans = this.answers;
    if (q.when && !Object.keys(q.when).every(function (k) {
      var want = q.when[k]; var have = ans[k] || [];
      return want.some(function (w) { return have.indexOf(w) >= 0; });
    })) return false;
    if (q.when_not && Object.keys(q.when_not).some(function (k) {
      var bad = q.when_not[k]; var have = ans[k] || [];
      return bad.some(function (w) { return have.indexOf(w) >= 0; });
    })) return false;
    return true;
  };

  Quiz.prototype.frame = function (opts) {
    var self = this;
    var f = el('div', 'lvq-frame');
    var top = el('div', 'lvq-top');
    var back = el('button', 'lvq-back', '<span aria-hidden="true">&larr;</span> Back'); back.type = 'button';
    back.hidden = !opts.back;
    back.addEventListener('click', function () { self.back(); });
    var quit = el('button', 'lvq-quit', 'Quit <span aria-hidden="true">&times;</span>'); quit.type = 'button';
    quit.addEventListener('click', function () { self.quit(); });
    top.appendChild(back); top.appendChild(quit);
    f.appendChild(top);
    return f;
  };

  Quiz.prototype.show = function (id) {
    var self = this;
    if (id === '__email') return this.showEmail();
    var q = this.question(id); if (!q) return this.showEmail();
    this.current = id;
    var f = this.frame({ back: this.history.length > 0 });
    var body = el('div', 'lvq-body');
    body.appendChild(el('h2', 'lvq-title', esc(q.title)));
    if (q.hint) body.appendChild(el('p', 'lvq-hint', esc(q.hint)));
    var hasImg = q.answers.some(function (a) { return a.img; });
    var list = el('div', 'lvq-answers' + (hasImg ? ' lvq-answers--cards' : ''));
    list.setAttribute('role', q.type === 'multi' ? 'group' : 'radiogroup');
    var picked = (this.answers[q.key] || []).slice();
    q.answers.forEach(function (a) {
      var b = el('button', 'lvq-answer' + (hasImg ? ' lvq-answer--card' : ''));
      b.type = 'button'; b.setAttribute('role', q.type === 'multi' ? 'checkbox' : 'radio');
      b.setAttribute('aria-checked', picked.indexOf(a.id) >= 0 ? 'true' : 'false');
      if (hasImg) {
        var imgUrl = a.img && a.img.indexOf('{{ASSET}}') === 0 ? self.assetBase + a.img.slice(9) : a.img;
        b.innerHTML = (imgUrl ? '<img src="' + esc(imgUrl) + '" alt="" loading="lazy">' : '') +
          '<span class="lvq-answer__label">' + esc(a.label) + '</span>' +
          (a.desc ? '<span class="lvq-answer__desc">' + esc(a.desc) + '</span>' : '') +
          '<span class="lvq-answer__dot" aria-hidden="true"></span>';
      } else {
        b.textContent = a.label;
      }
      b.addEventListener('click', function () {
        if (q.type === 'multi') {
          var i = picked.indexOf(a.id); if (i >= 0) picked.splice(i, 1); else picked.push(a.id);
          b.setAttribute('aria-checked', i >= 0 ? 'false' : 'true');
          submit.disabled = picked.length === 0;
        } else {
          picked = [a.id];
          self.commit(q, picked);
        }
      });
      list.appendChild(b);
    });
    body.appendChild(list);
    var submit = el('button', 'lvq-submit', 'Submit'); submit.type = 'button';
    submit.hidden = q.type !== 'multi'; submit.disabled = picked.length === 0;
    submit.addEventListener('click', function () { if (picked.length) self.commit(q, picked); });
    body.appendChild(submit);
    body.appendChild(el('p', 'lvq-foot', esc(this.cfg.copy.progress || 'Just a few questions...')));
    f.appendChild(body);
    this.panel.innerHTML = ''; this.panel.appendChild(f);
    this.panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Quiz.prototype.commit = function (q, picked) {
    this.answers[q.key] = picked.slice();
    this.history.push(q.id);
    this.show(this.nextId(q, picked));
  };

  Quiz.prototype.back = function () {
    if (this.current === '__email' || this.current === '__results') { var last = this.history[this.history.length - 1]; this.history.pop(); return this.show(last); }
    var prev = this.history.pop();
    if (prev) this.show(prev); else this.quit();
  };

  /* ---------- email gate ---------- */
  Quiz.prototype.showEmail = function () {
    var self = this; this.current = '__email';
    var c = this.cfg.copy;
    var f = this.frame({ back: true });
    var body = el('div', 'lvq-body lvq-body--email');
    body.appendChild(el('h2', 'lvq-title', esc(c.email_title || 'Awesome!')));
    body.appendChild(el('p', 'lvq-sub', esc(c.email_subtitle || 'Time to meet your perfect match.')));
    body.appendChild(el('p', 'lvq-hint', esc(c.email_text || "If you'd like, leave your email below to unlock many benefits available to our subscribers.")));
    var form = el('form', 'lvq-email'); form.noValidate = true;
    form.innerHTML =
      '<label class="lvq-visually-hidden" for="lvq-email-' + esc(this.section.id) + '">E-mail</label>' +
      '<input id="lvq-email-' + esc(this.section.id) + '" class="lvq-input" type="email" name="email" autocomplete="email" placeholder="Enter your email" required>' +
      '<label class="lvq-check"><input type="checkbox" name="privacy" required> <span>I agree with the <a href="' + esc(this.section.getAttribute('data-privacy-url') || '/policies/privacy-policy') + '" target="_blank" rel="noopener">Privacy policy</a></span></label>' +
      '<p class="lvq-error" hidden></p>' +
      '<div class="lvq-actions"><button type="submit" class="lvq-submit">Submit</button>' +
      '<button type="button" class="lvq-skip" data-skip>Skip to results</button></div>';
    var err = qs(form, '.lvq-error');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
      if (!form.privacy.checked) { err.textContent = 'Please accept the privacy policy to continue.'; err.hidden = false; return; }
      err.hidden = true;
      var r = self.recommend();
      self.sendKlaviyo(email, r); // fire and forget
      self.showResults(r, email);
    });
    qs(form, '[data-skip]').addEventListener('click', function () { self.showResults(self.recommend(), null); });
    body.appendChild(form);
    f.appendChild(body);
    this.panel.innerHTML = ''; this.panel.appendChild(f);
    this.panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ---------- recommendation ----------
   * cfg.products[handle] = { tags: {gender:[...], use:[...], stim:[...], clit:[...], control:[...]}, rank: n }
   * cfg.scoring = { require: ['gender','use'], score: ['stim','clit','control'], recs_by: 'stim', labels: {gspot:'G-spot stimulation',...} }
   * Top = product satisfying every `require` dimension, with the most matches on `score` dimensions, best lelo.com rank first.
   * Recommendations = for each selected value of `recs_by` (and `clit` when chosen), the best product tagged for it, excluding the top.
   */
  Quiz.prototype.recommend = function () {
    var cfg = this.cfg, ans = this.answers, sc = cfg.scoring;
    var handles = Object.keys(cfg.products);
    function has(tags, dim, vals) { var t = tags[dim] || []; return vals.some(function (v) { return t.indexOf(v) >= 0; }); }
    var eligible = handles.filter(function (h) {
      var t = cfg.products[h].tags;
      return sc.require.every(function (dim) { var want = ans[dim]; return !want || !want.length || has(t, dim, want); });
    });
    if (!eligible.length) eligible = handles.slice();
    function score(h) {
      var t = cfg.products[h].tags, s = 0;
      sc.score.forEach(function (dim) { (ans[dim] || []).forEach(function (v) { if ((t[dim] || []).indexOf(v) >= 0) s += (sc.weights && sc.weights[dim]) || 1; }); });
      return s;
    }
    eligible.sort(function (a, b) { return score(b) - score(a) || (cfg.products[a].rank || 999) - (cfg.products[b].rank || 999); });
    var top = eligible[0];
    var recs = [];
    var dims = [sc.recs_by].concat(sc.recs_extra || []);
    // per-answer recommendation: lelo.com shows one product per chosen answer value, from a per-value ranked list
    // (cfg.value_order, observed on lelo.com) falling back to the product's overall rank; never the headline product.
    // The card pool is filtered only by `recs_require` (gender) - lelo.com recommends solo toys to couples too -
    // and values listed in cfg.no_card never get a card (lelo.com shows none for them).
    var pool = handles.filter(function (h) {
      var t = cfg.products[h].tags;
      return (sc.recs_require || []).every(function (dim) { var want = ans[dim]; return !want || !want.length || has(t, dim, want); });
    });
    pool.sort(function (a, b) { return (cfg.products[a].rank || 999) - (cfg.products[b].rank || 999); });
    var noCard = cfg.no_card || [];
    // card order = question order, except that a question answered with several values gets its cards after the
    // single-value ones (lelo.com: G-spot+Clitoral / Suction / Strong -> Suction, Strong, G-spot; 4th card cut by max_recs)
    var items = [];
    dims.forEach(function (dim, di) {
      var vals = ans[dim] || [];
      vals.forEach(function (v, vi) { items.push({ dim: dim, v: v, multi: vals.length > 1 ? 1 : 0, di: di, vi: vi }); });
    });
    items.sort(function (a, b) { return a.multi - b.multi || a.di - b.di || a.vi - b.vi; });
    items.forEach(function (it) {
      var dim = it.dim, v = it.v;
      {
        if (noCard.indexOf(v) >= 0) return;
        var pref = (cfg.value_order && cfg.value_order[v]) || [];
        var cands = pool.filter(function (h) { return h !== top && (cfg.products[h].tags[dim] || []).indexOf(v) >= 0 && recs.map(function (r) { return r.handle; }).indexOf(h) < 0; });
        cands.sort(function (a, b) {
          var pa = pref.indexOf(a), pb = pref.indexOf(b);
          pa = pa < 0 ? 999 : pa; pb = pb < 0 ? 999 : pb;
          return pa - pb || (cfg.products[a].rank || 999) - (cfg.products[b].rank || 999);
        });
        if (cands[0]) recs.push({ handle: cands[0], label: (sc.labels && sc.labels[v]) || v });
      }
    });
    recs = recs.slice(0, sc.max_recs || 3);
    return { top: top, recs: recs, answers: ans };
  };

  /* ---------- results ---------- */
  Quiz.prototype.product = function (handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  };

  Quiz.prototype.showResults = function (r, email) {
    var self = this; this.current = '__results';
    var f = this.frame({ back: false });
    var body = el('div', 'lvq-body lvq-body--results');
    body.appendChild(el('div', 'lvq-loading', 'Finding your match…'));
    f.appendChild(body);
    this.panel.innerHTML = ''; this.panel.appendChild(f);
    var handles = [r.top].concat(r.recs.map(function (x) { return x.handle; }));
    Promise.all(handles.map(function (h) { return self.product(h).catch(function () { return null; }); })).then(function (prods) {
      body.innerHTML = '';
      var top = prods[0];
      if (!top) { body.appendChild(el('p', 'lvq-hint', 'We could not load your match. <a href="/collections/bestsellers">See our bestsellers</a>.')); return; }
      var hero = el('div', 'lvq-result');
      var img = top.featured_image || (top.images && top.images[0]) || (top.media && top.media[0] && top.media[0].src) || '';
      var desc = (top.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      if (desc.length > 520) desc = desc.slice(0, 520).replace(/\s+\S*$/, '') + '…';
      var v = (top.variants || []).filter(function (x) { return x.available; })[0] || (top.variants || [])[0];
      hero.innerHTML =
        '<div class="lvq-result__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(top.title) + '">' : '') + '</div>' +
        '<div class="lvq-result__info">' +
          '<h2 class="lvq-title lvq-title--left">' + esc(self.cfg.copy.meet || 'Meet') + ' ' + esc(top.title) + '</h2>' +
          (v ? '<p class="lvq-price">' + esc(money(v.price, self.moneyFormat)) + '</p>' : '') +
          '<p class="lvq-desc">' + esc(desc) + '</p>' +
          '<div class="lvq-actions">' +
            (v ? '<button type="button" class="lvq-submit" data-add="' + v.id + '">Add to cart</button>' : '') +
            '<a class="lvq-skip" href="/products/' + esc(top.handle) + '">See details</a>' +
          '</div>' +
          '<button type="button" class="lvq-retake" data-retake>&#8635; Retake quiz</button>' +
        '</div>';
      body.appendChild(hero);
      var cards = prods.slice(1).map(function (p, i) { return p ? { p: p, label: r.recs[i].label } : null; }).filter(Boolean);
      if (cards.length) {
        var wrap = el('div', 'lvq-recs');
        wrap.appendChild(el('h3', 'lvq-recs__title', esc(self.cfg.copy.recs_title || 'Our recommendations based on your answers:')));
        var row = el('div', 'lvq-recs__row');
        cards.forEach(function (c) {
          var cv = (c.p.variants || []).filter(function (x) { return x.available; })[0] || (c.p.variants || [])[0];
          var ci = c.p.featured_image || (c.p.images && c.p.images[0]) || (c.p.media && c.p.media[0] && c.p.media[0].src) || '';
          var card = el('div', 'lvq-card');
          card.innerHTML =
            '<p class="lvq-card__cat">' + esc(c.label) + '</p>' +
            '<a class="lvq-card__media" href="/products/' + esc(c.p.handle) + '">' + (ci ? '<img src="' + esc(ci) + '" alt="' + esc(c.p.title) + '" loading="lazy">' : '') + '</a>' +
            '<h4 class="lvq-card__title"><a href="/products/' + esc(c.p.handle) + '">' + esc(c.p.title) + '</a></h4>' +
            '<p class="lvq-card__type">' + esc(c.p.type || '') + (cv ? ' · ' + esc(money(cv.price, self.moneyFormat)) : '') + '</p>' +
            (cv ? '<button type="button" class="lvq-submit lvq-submit--small" data-add="' + cv.id + '">Add to cart</button>' : '');
          row.appendChild(card);
        });
        wrap.appendChild(row); body.appendChild(wrap);
      }
      body.querySelectorAll('[data-add]').forEach(function (b) {
        b.addEventListener('click', function () { self.addToCart(b.getAttribute('data-add'), b); });
      });
      qs(body, '[data-retake]').addEventListener('click', function () { self.start(); });
      self.track('quiz_completed', { top_product: top.handle, recommended: handles.slice(1), answers: r.answers, email_given: !!email });
    });
  };

  Quiz.prototype.addToCart = function (variantId, btn) {
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { btn.textContent = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:updated')); setTimeout(function () { window.location.href = '/cart'; }, 600); })
      .catch(function () { btn.disabled = false; btn.textContent = label; alert('Sorry, that could not be added to the cart.'); });
  };

  /* ---------- Klaviyo (client API, public company id) ---------- */
  Quiz.prototype.sendKlaviyo = function (email, r) {
    var k = this.klaviyo; if (!k.company) return;
    var props = { top_product: r.top, recommended_products: r.recs.map(function (x) { return x.handle; }), source: 'lelo-to sex toy quiz' };
    var self = this;
    Object.keys(r.answers).forEach(function (key) { props['q_' + key] = r.answers[key].map(function (id) { return self.label(key, id); }); });
    var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
    var base = 'https://a.klaviyo.com/client/';
    var profileAttrs = { email: email, properties: { last_quiz_top_product: r.top, last_quiz_completed_at: new Date().toISOString() } };
    fetch(base + 'events/?company_id=' + encodeURIComponent(k.company), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'event', attributes: {
      properties: props, metric: { data: { type: 'metric', attributes: { name: k.metric } } }, profile: { data: { type: 'profile', attributes: profileAttrs } } } } }) }).catch(function () {});
    if (k.list) {
      fetch(base + 'subscriptions/?company_id=' + encodeURIComponent(k.company), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'LELO.TO Sex Toy Quiz', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: k.list } } } } }) }).catch(function () {});
    }
  };

  Quiz.prototype.label = function (key, id) {
    for (var i = 0; i < this.cfg.questions.length; i++) {
      var q = this.cfg.questions[i]; if (q.key !== key) continue;
      for (var j = 0; j < q.answers.length; j++) if (q.answers[j].id === id) return q.answers[j].label;
    }
    return id;
  };

  Quiz.prototype.track = function (name, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  };

  function init() {
    document.querySelectorAll('[data-lelo-quiz]').forEach(function (s) { if (!s.__quiz) s.__quiz = new Quiz(s); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
